module.exports = __webpack_public_path__ + "assets/img/empty.41ca6284.svg";